import Barba from 'barba.js';
import $ from 'jquery';
import map from '../../modules/map.js';

var contactView = function () {

	var Contact = Barba.BaseView.extend({
		namespace: 'contact',
		onEnter: function () {
			map();
		},
		onEnterCompleted: function () {
			$(window).scroll();

			setTimeout(function() {
				let all_text = '';
				if($('.body-wrapper').hasClass('body-wrapper__contact'))
				{
					if($('#gform_wrapper_1').is(':visible'))
					{
						return;
					}
					else
					{
						//don't reload on after form submission 
						if(0 === $('#gform_confirmation_wrapper_1').length)
						{
							//reload after barba transition to show form
							location.reload();
						}
					}
				}

				$('body').find('script').each(function(){
					let text = $(this).text();
					if(all_text.includes(text))
					{
						//Already run
					}
					else
					{
						all_text += text;
						eval(text);
					}
				});
			}, 250 );

		},
		onLeave: function () {

		},
		onLeaveCompleted: function () {

		}
	});

	Contact.init();
}

module.exports = contactView;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/views/contact-view.js